export const connectionStati = {
  notConnected: 'notConnected',
  requested: 'requested',
  connected: 'connected',
  denied: 'denied',
}
